import React, { useEffect, useState } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import { lojaAction, relatorioAction } from '../../_actions'
import PropTypes from 'prop-types'
import { toast } from 'react-toastify'
import Autocomplete from '@material-ui/lab/Autocomplete';
import {
  Button,
  Card,
  CardContent,
  CircularProgress,
  Grid,
  Link,
  Paper,
  Table,
  TableContainer,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  withStyles
} from '@material-ui/core'
import {
  ValidatorForm,
  TextValidator
} from 'react-material-ui-form-validator'
import Skeleton from "@material-ui/lab/Skeleton"
import { withRouter } from 'react-router-dom'
import TitleContentInformation from '../TitleContentInformation'
import { AccessControl } from '../../components/Utils/AccessControl'
import AccessDenied from '../Errors/AccessDenied'
import SearchIcon from '@material-ui/icons/Search';
import PrintIcon from '@material-ui/icons/Print'
import { Page } from 'components'
import moment from 'moment'

const styles = (theme) => ({
  root: {
    padding: theme.spacing(2)
  },
  gridButton: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'right',
    textAlign: 'right'
  }
})

const RelatorioTroca = (props) => {
  const dispatch = useDispatch()
  const { classes, className, ...rest } = props
  const { relatorio } = props.relatorio
  const { totalRegistros } = props.relatorio
  const { isLoading } = props.relatorio

  const [dataInicial, setDataInicial] = useState(undefined)
  const [dataFinal, setDataFinal] = useState(undefined)
  const [produtoRef, setProdutoRef] = useState('')

  const [valueLojas, setValueLojas] = useState([]);

  const { idLoja } = useSelector((state) => state.usuarioLoja)
  const lojas = useSelector((state) => state.loja.loja)

  let idLojas = []

  useEffect(() => {
    const dataIni = moment().subtract(1, "months")
    const dataFi = moment();

    setDataInicial(moment(dataIni).format("YYYY-MM-DD"));
    setDataFinal(moment(dataFi).format("YYYY-MM-DD"));

    dispatch(lojaAction.getLojasUsuarioSelect())
    dispatch(relatorioAction.clear());
  }, []);

  useEffect(() => {
    let valueLoja = null

    if (idLoja > 0) {
      let lojaIdHeader = lojas.indexOf(lojas.find((l) => l.value == idLoja))

      valueLoja = lojas[lojaIdHeader]
    }

    setValueLojas(valueLoja ? [valueLoja] : [])
  }, [idLoja, lojas])

  const handleChangeLojas = (value) => {
    setValueLojas(value);
  };

  const handleSubmit = (event) => {
    idLojas = valueLojas.map(l => Number(l.value))

    let payload = {
      DataInicial: moment(dataInicial).format("YYYY-MM-DDTHH:mm:ssZ"),
      DataFinal: moment(dataFinal).format("YYYY-MM-DDTHH:mm:ssZ"),
      Nome: produtoRef,
      CodigoProduto: 0,
      ...(idLojas && idLojas.length > 0 ? { IdLojas: idLojas } : {}),
    };

    dispatch(relatorioAction.getRelatorioTroca(payload, true));
  };

  const handleChangeDataInicial = (e) => {
    setDataInicial(e.target.value)
  }

  const handleChangeDataFinal = (e) => {
    setDataFinal(e.target.value)
  }

  const handleChangeProdutoRef = (e) => {
    setProdutoRef(e.target.value)
  }

  const handlePrint = () => {
    window.open('/relatorioTroca', '_blank');
  }

  function TotalRow() {
    return (
      undefined !== relatorio && relatorio.length
        ?
        <TableRow>
          <TableCell rowSpan={1} colSpan={7}><b>Total</b></TableCell>
          <TableCell rowSpan={1} align="right"><b>{totalRegistros}</b></TableCell>
        </TableRow>
        :
        null
    )
  }

  return (
    <Page className={classes.root} title="Relatório - Trocas por Período">
      <AccessControl
        rule={'relatorios.list'} //permissão necessária para acessar conteúdo
        yes={() => (
          <Grid
            {...rest}
            container
            spacing={2}
          >
            <Grid item lg={12} md={12} xl={12} xs={12}>
              <Card style={{ marginBottom: 10, marginTop: 0 }}>
                <ValidatorForm
                  id="formRelatorioTrocas"
                  onSubmit={(event) => handleSubmit(event)}
                >
                  <CardContent>
                    <TitleContentInformation
                      subTitle={'RELATÓRIO'}
                      title={'Trocas por Período'}
                    />
                    <Grid container spacing={2}>
                      <Grid item lg={2} md={2} xl={2} xs={6}>
                        <TextValidator
                          InputLabelProps={{ shrink: true }}
                          className={classes.textField}
                          variant="outlined"
                          margin="normal"
                          fullWidth
                          label="Início *"
                          type="date"
                          value={dataInicial}
                          onChange={handleChangeDataInicial}
                          id="dataInicial"
                          validators={['required']}
                          errorMessages={['Campo obrigatório!']}
                        />
                      </Grid>
                      <Grid item lg={2} md={2} xl={2} xs={6}>
                        <TextValidator
                          InputLabelProps={{ shrink: true }}
                          className={classes.textField}
                          variant="outlined"
                          margin="normal"
                          fullWidth
                          label="Final *"
                          type="date"
                          value={dataFinal}
                          onChange={handleChangeDataFinal}
                          id="dataFinal"
                          validators={['required']}
                          errorMessages={['Campo obrigatório!']}
                        />
                      </Grid>
                      <Grid item xl={8} lg={8} md={8} xs={12}>
                        <TextValidator
                          InputLabelProps={{ shrink: true }}
                          className={classes.textField}
                          variant="outlined"
                          margin="normal"
                          fullWidth
                          label="Produto / Referência"
                          value={produtoRef}
                          onChange={handleChangeProdutoRef}
                          id="produtoRef"
                        />
                      </Grid>
                    </Grid>
                    <Grid container spacing={2} style={{ alignItems: 'center', justifyContent: 'left', alignContent: 'left' }}>
                      <Grid item lg={12} md={12} xl={12} xs={12} style={{ paddingBottom: "15px" }}>
                        <Autocomplete
                          multiple
                          id="lojasSelecionadas"
                          value={valueLojas}
                          options={lojas}
                          getOptionLabel={(option) => option.text}
                          onChange={(event, value) => handleChangeLojas(value)}
                          fullWidth
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              label="Selecione as lojas"
                            />
                          )}
                        />
                      </Grid>
                      <Grid container>
                        <Grid item xl={12} lg={12} md={12} xs={12} style={{
                          alignItems: 'bottom',
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: 'right',
                          textAlign: 'right',
                          gap: 6
                        }}>
                          <Grid>
                            <Button
                              color="primary"
                              type="submit"
                              variant="contained"
                              disabled={props.relatorio.isLoading}
                              startIcon={<SearchIcon />}
                              endIcon={props.relatorio.isLoading && <CircularProgress size={24} />}
                            >
                              {props.relatorio.isLoading ? 'Pesquisando...' : 'Pesquisar'}
                            </Button>
                          </Grid>
                          <Grid>
                            <Button
                              color="primary"
                              type="submit"
                              onClick={() => handlePrint()}
                              variant="outlined"
                              startIcon={<PrintIcon />}
                            >
                              Imprimir
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </CardContent>
                </ValidatorForm>
              </Card>
              <Card>
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Data</TableCell>
                        <TableCell>Loja</TableCell>
                        <TableCell>Voucher</TableCell>
                        <TableCell>Produto</TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell>Motivo Erro</TableCell>
                        <TableCell>Cliente</TableCell>
                        <TableCell align="right">Ticket médio do cliente no dia</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TotalRow />
                      {undefined !== relatorio && relatorio.length
                        ? relatorio.map((n) => {
                          return (
                            <TableRow hover key={n.id}>
                              <TableCell component="th" scope="row">
                                {moment(n.data).format("DD/MM/YYYY")}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {n.loja || ''}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {n.voucher || ''}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {n.descricaoProduto || ''}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {n.status && n.status == true || n.status == null ? 'PROCESSADO' : 'PENDENTE'}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {n.motivoErro || ''}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                <Link color="inherit" href={"/cliente/" + n.cliente.id} target="_blank" style={{ paddingLeft: 15, verticalAlign: 'center', justifyContent: 'start' }}>
                                  {n.cliente.nome || ''}
                                </Link>
                              </TableCell>
                                <TableCell component="th" scope="row" align="right">
                                  {'R$ ' + parseFloat(n.valorFidelidadeDiaTroca).toLocaleString('pt-br', { maximumFractionDigits: 2, minimumFractionDigits: 2 }) || ''}
                                </TableCell>
                            </TableRow>
                          )
                        })
                        :
                        (dataInicial != undefined && dataFinal != undefined ?
                          (isLoading ?
                            Array.apply(null, { length: 7 }).map((e, i) => (
                              <TableRow hover key={i}>
                                <TableCell component="th" scope="row">
                                  <Skeleton animation="wave" />
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  <Skeleton animation="wave" />
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  <Skeleton animation="wave" />
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  <Skeleton animation="wave" />
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  <Skeleton animation="wave" />
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  <Skeleton animation="wave" />
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  <Skeleton animation="wave" />
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  <Skeleton animation="wave" />
                                </TableCell>
                              </TableRow>
                            ))
                            :
                            <TableRow>
                              <TableCell rowSpan={7} colSpan={8} align="center">Nenhum registro encontrado</TableCell>
                            </TableRow>
                          )
                          :
                          <TableRow>
                            <TableCell rowSpan={7} colSpan={8} align="center">Informe uma Data de Início e uma Data de Final</TableCell>
                          </TableRow>
                        )
                      }
                      <TotalRow />
                    </TableBody>
                  </Table>
                </TableContainer>
              </Card>
            </Grid>
          </Grid>
        )
        }
        no={() => <AccessDenied />}
      />
    </Page >
  )
}
RelatorioTroca.propTypes = {
  classes: PropTypes.object.isRequired
}
const mapStateToProps = (state) => {
  return state
}
const connectedRelatorioTrocaPage = withRouter(
  connect(mapStateToProps, null, null, {
    pure: false
  })(withStyles(styles)(RelatorioTroca))
)
export { connectedRelatorioTrocaPage as RelatorioTroca }
